(function () {
  'use strict';

  if (window.BadeloftHomepageEffectsReady) return;
  window.BadeloftHomepageEffectsReady = true;

  function waitForGsap(callback) {
    if (window.gsap && window.ScrollTrigger) {
      callback();
      return;
    }

    var interval = window.setInterval(function () {
      if (window.gsap && window.ScrollTrigger) {
        window.clearInterval(interval);
        callback();
      }
    }, 50);

    window.setTimeout(function () {
      window.clearInterval(interval);
    }, 8000);
  }

  function initEffects() {
    var gsap = window.gsap;
    var ScrollTrigger = window.ScrollTrigger;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    gsap.registerPlugin(ScrollTrigger);

    document.querySelectorAll('[data-hp-reveal]').forEach(function (element) {
      if (element.dataset.hpRevealReady) return;
      element.dataset.hpRevealReady = 'true';

      if (reducedMotion) {
        gsap.set(element, { autoAlpha: 1, y: 0 });
        return;
      }

      gsap.fromTo(
        element,
        { autoAlpha: 0, y: 28 },
        {
          autoAlpha: 1,
          y: 0,
          duration: 0.9,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: element,
            start: 'top 86%',
            once: true
          }
        }
      );
    });

    document.querySelectorAll('[data-hp-stagger]').forEach(function (group) {
      if (group.dataset.hpStaggerReady) return;
      group.dataset.hpStaggerReady = 'true';
      var items = group.querySelectorAll('[data-hp-stagger-item]');
      if (!items.length) return;

      if (reducedMotion) {
        gsap.set(items, { autoAlpha: 1, y: 0 });
        return;
      }

      gsap.fromTo(
        items,
        { autoAlpha: 0, y: 26 },
        {
          autoAlpha: 1,
          y: 0,
          duration: 0.8,
          ease: 'power3.out',
          stagger: 0.09,
          scrollTrigger: {
            trigger: group,
            start: 'top 82%',
            once: true
          }
        }
      );
    });

    document.querySelectorAll('[data-hp-parallax]').forEach(function (media) {
      if (media.dataset.hpParallaxReady || reducedMotion) return;
      media.dataset.hpParallaxReady = 'true';

      gsap.fromTo(
        media,
        { yPercent: -4, scale: 1.05 },
        {
          yPercent: 4,
          scale: 1.05,
          ease: 'none',
          scrollTrigger: {
            trigger: media.closest('section') || media,
            start: 'top bottom',
            end: 'bottom top',
            scrub: true
          }
        }
      );
    });

    document.querySelectorAll('[data-hp-tilt]').forEach(function (card) {
      if (card.dataset.hpTiltReady || reducedMotion) return;
      card.dataset.hpTiltReady = 'true';

      card.addEventListener('mousemove', function (event) {
        var rect = card.getBoundingClientRect();
        var x = (event.clientX - rect.left) / rect.width - 0.5;
        var y = (event.clientY - rect.top) / rect.height - 0.5;
        gsap.to(card, {
          x: x * 8,
          y: y * 8,
          rotateX: y * -2.4,
          rotateY: x * 2.4,
          duration: 0.45,
          ease: 'power3.out'
        });
      });

      card.addEventListener('mouseleave', function () {
        gsap.to(card, {
          x: 0,
          y: 0,
          rotateX: 0,
          rotateY: 0,
          duration: 0.6,
          ease: 'power3.out'
        });
      });
    });

    document.querySelectorAll('[data-hp-count]').forEach(function (counter) {
      if (counter.dataset.hpCountReady || reducedMotion) return;
      counter.dataset.hpCountReady = 'true';
      var endValue = parseFloat(counter.dataset.hpCount || '0');
      var suffix = counter.dataset.hpSuffix || '';
      var decimals = parseInt(counter.dataset.hpDecimals || '0', 10);
      var state = { value: 0 };

      gsap.to(state, {
        value: endValue,
        duration: 1.25,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: counter,
          start: 'top 88%',
          once: true
        },
        onUpdate: function () {
          counter.textContent = state.value.toFixed(decimals) + suffix;
        }
      });
    });
  }

  function boot() {
    waitForGsap(initEffects);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
